// @ts-nocheck

/**
 * YPM_USER_MATERIAL_AUTH_SRV
 * User Material Authorization  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[UserAuthorizationGroup{bg:orange}],[VendorMaterialAuthorization{bg:orange}],[VendorDocumentAuthorization{bg:orange}],[UserRoles{bg:orange}],[UserAuthorizationGroupSet{bg:dodgerblue}]++-*>[UserAuthorizationGroup],[VendorMaterialAuthorizationSet{bg:dodgerblue}]++-*>[VendorMaterialAuthorization],[VendorDocumentAuthorizationSet{bg:dodgerblue}]++-*>[VendorDocumentAuthorization],[UserRolesSet{bg:dodgerblue}]++-*>[UserRoles])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ModelError } from '../model/models';
import { UserAuthorizationGroup } from '../model/models';
import { Wrapper } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class UserAuthorizationGroupSetService {

    protected basePath = 'https://sapd42c00.sap.corp.lego.com:22000/sap/opu/odata/sap/YPM_USER_MATERIAL_AUTH_SRV';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entities from UserAuthorizationGroupSet
     * @param search Search items by search phrases, see [Searching](https://wiki.scn.sap.com/wiki/display/EmTech/SAP+Annotations+for+OData+Version+2.0#SAPAnnotationsforODataVersion2.0-Query_Option_searchQueryOptionsearch)
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userAuthorizationGroupSetGet(search?: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper>;
    public userAuthorizationGroupSetGet(search?: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper>>;
    public userAuthorizationGroupSetGet(search?: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper>>;
    public userAuthorizationGroupSetGet(search?: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>search, 'search');
        }
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper>(`${this.configuration.basePath}/UserAuthorizationGroupSet`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entity from UserAuthorizationGroupSet by key
     * @param userID userID
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userAuthorizationGroupSetUserIDGet(userID: string, $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserAuthorizationGroup>;
    public userAuthorizationGroupSetUserIDGet(userID: string, $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserAuthorizationGroup>>;
    public userAuthorizationGroupSetUserIDGet(userID: string, $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserAuthorizationGroup>>;
    public userAuthorizationGroupSetUserIDGet(userID: string, $select?: Array<'userID' | 'emailAddress' | 'authorizationGroup'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userID === null || userID === undefined) {
            throw new Error('Required parameter userID was null or undefined when calling userAuthorizationGroupSetUserIDGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserAuthorizationGroup>(`${this.configuration.basePath}/UserAuthorizationGroupSet('${encodeURIComponent(String(userID))}')`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
